export enum ProjectRepeatPeriod {
  None = 0,
  EveryDay = 1,
  EveryWeek = 2,
  EveryMonth = 3,
}
